import './LogpointsCreateManual.scss';
import * as React from 'react';
import { observer } from 'mobx-react';
import { makeObservable, observable } from 'mobx';
import { FiletreeSelect } from '@shared/ui-react/FiletreeSelect';
import { FormGroup } from '@shared/ui-react/UtilComponents';
import { LogpointsService } from '@shared/logpoints/LogpointsService';
import { Notify } from '@shared/ui-native/Notify';
import { Button } from '@shared/ui-react/Button';
import { LStorage } from '@shared/Storage';
import { ProjectCodesService } from '@shared/services/ProjectCodesService';

@observer
export class LogpointsCreateManual extends React.Component<
    {
        lat: string;
        lon: string;
        n: number;
        e: number;
        z: number;
        treeData: ITreeData;
        onClose: Function;
        onSave: (logpoint: ILogpoint) => void;
        defaultFolderId?: number;
        defaultModelId?: number;
        defaultAlignmentId?: number;
    },
    {}
> {
    private readonly storageKey = 'create-logpoint-manual-location-mode';

    @observable locationMode = LStorage.getOrDefault(this.storageKey, 'latlon');

    @observable
    form: Partial<ILogpoint & { n: number; e: number }> = {
        id: null,
        lat: this.props.lat,
        lon: this.props.lon,
        folderId: this.props.defaultFolderId,
        modelId: this.props.defaultModelId || -1,
        alignmentId: this.props.defaultAlignmentId || -1,
        code: '',
        linecode: '',
        number: '',
        pointName: '',
        surfacecode: '',
        type: 'MANUAL',
        n: this.props.n,
        e: this.props.e,
        z: this.props.z,
    };

    @observable isLoading = false;

    constructor(props: any) {
        super(props);
        makeObservable(this);
    }

    componentDidMount(): void {
        // react events dont work inside openlayers overlay
        document.getElementById('LogpointsCreateManualCloseBtn').addEventListener('click', () => this.props.onClose());
        document.getElementById('LogpointsCreateManualCreateBtn').addEventListener('click', () => this.create());
        document.getElementById('LogpointsCreateManualPositionLatlon').addEventListener('click', () => {
            this.locationMode = 'latlon';
            LStorage.setItem(this.storageKey, this.locationMode);
        });
        document.getElementById('LogpointsCreateManualPositionNez').addEventListener('click', () => {
            this.locationMode = 'nez';
            LStorage.setItem(this.storageKey, this.locationMode);
        });
    }

    render() {
        const { lat, lon, treeData } = this.props;

        return (
            <div id='logpoint-create-manual'>
                <FormGroup title={__('general.position')}>
                    <div className='flex-row'>
                        <label className='checkbox-label' id='LogpointsCreateManualPositionLatlon'>
                            <input type='radio' readOnly checked={this.locationMode === 'latlon'} />
                            lat/lon
                        </label>
                        <label className='checkbox-label' id='LogpointsCreateManualPositionNez'>
                            <input type='radio' readOnly checked={this.locationMode === 'nez'} />
                            xyz
                        </label>
                    </div>

                    {this.locationMode === 'latlon' && (
                        <div className='flex-row'>
                            <FormGroup title='Lat'>
                                <input type='number' value={this.form.lat} onChange={e => (this.form.lat = e.currentTarget.value as any)} />
                            </FormGroup>
                            <div style={{ marginLeft: '10px', flexGrow: 1 }}>
                                <FormGroup title='Lon'>
                                    <input type='number' value={this.form.lon} onChange={e => (this.form.lon = e.currentTarget.value as any)} />
                                </FormGroup>
                            </div>
                        </div>
                    )}

                    {this.locationMode === 'nez' && (
                        <div className='flex-row coordinates-wrapper'>
                            <FormGroup title='X'>
                                <input type='number' value={this.form.n} onChange={e => (this.form.n = e.currentTarget.value as any)} />
                            </FormGroup>
                            <div style={{ marginLeft: '10px' }}>
                                <FormGroup title='Y'>
                                    <input type='number' value={this.form.e} onChange={e => (this.form.e = e.currentTarget.value as any)} />
                                </FormGroup>
                            </div>
                            <div style={{ marginLeft: '10px' }}>
                                <FormGroup title='Z'>
                                    <input type='number' value={this.form.z} onChange={e => (this.form.z = e.currentTarget.value as any)} />
                                </FormGroup>
                            </div>
                        </div>
                    )}
                </FormGroup>

                <FormGroup title={__('general.folder')}>
                    <FiletreeSelect
                        name='folderId'
                        filetreeData={treeData}
                        firstEmpty={false}
                        includeRoot={true}
                        value={this.form.folderId}
                        onChange={id => (this.form.folderId = id)}
                    />
                </FormGroup>

                <FormGroup title={__('general.model')}>
                    <FiletreeSelect
                        name='modelId'
                        filetreeData={treeData}
                        includeFiles={true}
                        firstEmpty={true}
                        firstEmptyText={__('js_logpoints.edit.no_model')}
                        hideEmptyFolders={true}
                        filter={this.filetreeFilterModels}
                        value={this.form.modelId}
                        onChange={id => (this.form.modelId = id)}
                    />
                </FormGroup>

                <FormGroup title={__('general.alignment')}>
                    <FiletreeSelect
                        name='alignmentId'
                        filetreeData={treeData}
                        includeFiles={true}
                        firstEmptyText={__('js_logpoints.edit.no_alignment')}
                        firstEmpty={true}
                        hideEmptyFolders={true}
                        filter={this.filetreeFilterAlignments}
                        value={this.form.alignmentId}
                        onChange={id => (this.form.alignmentId = id)}
                    />
                </FormGroup>

                <FormGroup title={__('js_logpoints.column_linecode')}>
                    <input type='text' value={this.form.linecode} onChange={e => (this.form.linecode = e.currentTarget.value)} />
                </FormGroup>

                <FormGroup title={__('js_logpoints.column_point_number')}>
                    <input type='text' value={this.form.number} onChange={e => (this.form.number = e.currentTarget.value)} />
                </FormGroup>

                <FormGroup title={__('js_logpoints.column_point_name')}>
                    <input type='text' value={this.form.pointName} onChange={e => (this.form.pointName = e.currentTarget.value)} />
                </FormGroup>

                <FormGroup title={__('js_logpoints.column_code')}>
                    <input type='text' list='projectCodes' value={this.form.code} onChange={e => (this.form.code = e.currentTarget.value)} />
                    <datalist id='projectCodes'>
                        {ProjectCodesService.getCodesArray().map(c => (
                            <option value={c}>{ProjectCodesService.codeWithDescription(c)}</option>
                        ))}
                    </datalist>
                    <div>{ProjectCodesService.getDescription(this.form.code)}</div>
                </FormGroup>

                <FormGroup title={__('js_logpoints.column_surfacecode')}>
                    <input type='text' value={this.form.surfacecode} onChange={e => (this.form.surfacecode = e.currentTarget.value)} />
                </FormGroup>

                <hr />
                <div className='btn-group' style={{ display: 'flex' }}>
                    <button id='LogpointsCreateManualCloseBtn'>
                        <i className='iki iki-cross' />
                    </button>
                    <Button id='LogpointsCreateManualCreateBtn' className='ik-button-primary block' loading={this.isLoading}>
                        {__('general.create')}
                    </Button>
                </div>
            </div>
        );
    }

    create = () => {
        this.isLoading = true;

        const formValue = { ...this.form };

        if (this.locationMode === 'latlon') {
            delete formValue.n;
            delete formValue.e;
            delete formValue.z;
        } else {
            delete formValue.lat;
            delete formValue.lon;
        }

        LogpointsService.create({
            ...formValue,
            surfaceCode: this.form.surfacecode,
            pointNumber: this.form.number,
            geoid: true,
        })
            .done(resp => {
                Notify.success();
                LogpointsService.fetchLogpoint(resp.id).done(l => this.props.onSave(l.ajaxLogpointData));
            })
            .fail(Notify.error)
            .always(() => {
                this.props.onClose();
            });
    };

    filetreeFilterModels(item) {
        if (item.tolerance) return true; // folder
        return kuuraModel.isModel(item);
    }

    filetreeFilterAlignments(item) {
        if (item.tolerance) return true; // folder
        return kuuraModel.isAlignment(item);
    }
}
